export const COOKIES_ENABLED = 'cookiesEnabled'
export const SCREEN_LOADING = 'screenLoading'

export const MASTER_NUMBER = 'masterNumber'
export const EMAIL_ADDRESS = 'emailAddress'
export const CONFIRM_EMAIL_ADDRESS = 'confirmEmailAddress'
export const PHONE_NUMBER = 'phoneNumber'

export const CLEAR_ALL = 'clearAll'
export const CLEAR_ALL_FIELDS = 'clearAllFields'
